import React, { Component } from 'react'

import idx from 'idx'
import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'

import ScreenSizeMessage from 'components/atoms/ScreenSizeMessage'
import GoodnatureAccountBanner from 'components/atoms/GoodnatureAccountBanner'

import * as userActions from 'actions/userActions'

const styles = theme => ({
  body: {
    display: 'flex',
  },
  content: {
    maxWidth: '100vw',
    maxHeight: '100vh',
  },
  children: {
    ...theme.animation.fadeIn,
  },
  left: {
    height: '100%',
    flex: '1 1 auto',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
  },
  right: {
    width: '40%',
    maxWidth: 600,
  },
})

class AccountScreenWrapper extends Component {
  state = {
    dashSize: false,
  };

  shouldComponentUpdate(nextProps) {
    return (
      idx(nextProps, _ => _.location.pathname) !==
      (idx(this.props, _ => _.location.pathname) || true)
    )
  }

  render() {
    const { classes } = this.props

    return (
      <section className={classes.body}>
        <Grid
          container
          alignItems="center"
          classes={{ container: classes.content }}>
          <Grid item classes={{ item: classes.left }}>
              <div className={classes.children}>{this.props.children}</div>
          </Grid>
          <Grid item classes={{ item: classes.right }}>
            <GoodnatureAccountBanner />
          </Grid>
        </Grid>
        <ScreenSizeMessage />
      </section>
    )
  }
}

AccountScreenWrapper.propTypes = {
  size: PropTypes.object,
  children: PropTypes.node,
  classes: PropTypes.object,
  actions: PropTypes.object,
  protected: PropTypes.bool,
  location: PropTypes.object,
}

function mapStateToProps(state) {
  return state
}

function mapDispatchToProps(dispatch) {
  const actions = Object.assign({}, userActions)
  return {
    actions: bindActionCreators(actions, dispatch),
  }
}

const WrapperComponent = withStyles(styles)(AccountScreenWrapper)

export default connect(mapStateToProps, mapDispatchToProps)(WrapperComponent)



// WEBPACK FOOTER //
// ./src/containers/core/AccountScreenWrapper/AccountScreenWrapper.js